import createSelectors from '../common/utils/selectorUtil';

import * as fromBD from './bd/vocabBDSelectors';
import * as fromFITB from './fitb/vocabFITBSelectors';
import * as fromTQVM from './tqvm/vocabTQVMSelectors';

const selectors = {
    ...createSelectors(fromTQVM, 'tqvm'),
    ...createSelectors(fromFITB, 'fitb'),
    ...createSelectors(fromBD, 'bd'),
};

export default selectors;
